import sectionTplaCss from '../css-snippets/section-tpla';

const html = `
<style>${sectionTplaCss}</style>
<div data-attribute="card-container" id="card-container-unique-id" data-id="unique-id" data-background="#ffffff"
  data-top-padding="false" data-bottom-padding="false"
  data-background-image="https://cdn.skyfastimg.com/images/2026/03/19/image-69bbb78f711b7db5e610a87f.png?"
  style="background-color: #ffffff; background-image: url(https://cdn.skyfastimg.com/images/2026/03/19/image-69bbb78f711b7db5e610a87f.png); --text-color: #ffffff; --border-color: #656464; --border-weight: 1px; padding-top: 0px; padding-bottom: 0px;"
  data-text-color="#ffffff">
  <div class="container-page" data-attribute="container-page" data-show-style="false" data-background="#FFFFFF"
    style="background-color: transparent;">
    <div class="container">
      <div class="wrap-card">
        <div data-attribute="title-card" class="title-card"></div>
        <div data-attribute="table-content" data-border-color="#656464" data-border-weight="1px" data-col-border="false"
          data-row-border="true" data-border-full="false" class="table-content">
          <figure class="table">
            <table class="ck-table-resized">
              <colgroup>
                <col style="width:53.18%;">
                <col style="width:26.16%;">
                <col style="width:20.66%;">
              </colgroup>
              <thead>
                <tr>
                  <th style="width:500px;">
                    <h3 style="text-align:justify;"><strong>TITANBOXERS VS other</strong></h3>
                  </th>
                  <th style="background-color:#4d4d4d59;vertical-align:bottom;width:500px;">
                    <figure class="image image_resized" style="width:100%;"><img
                        src="https://cdn.skyfastimg.com/images/2026/03/19/image-69bbb2f392bacfda76993616.png">
                    </figure>
                  </th>
                  <th style="vertical-align:bottom;width:500px;">
                    <figure class="image"><img
                        src="https://cdn.skyfastimg.com/images/2026/03/19/image-69bbb510e7f8c36183a70b63.png">
                    </figure>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="padding:16px;width:500px;">Underwear Look</td>
                  <td style="background-color:#4d4d4d59;padding:16px;width:500px;">
                    <figure class="image"><img
                        src="https://cdn.skyfastimg.com/images/2026/03/19/image-69bbbae77dd187b38abd302a.png">
                    </figure>
                  </td>
                  <td style="padding:16px;width:500px;">
                    <figure class="image"><img
                        src="https://cdn.skyfastimg.com/images/2026/03/19/image-69bbbb3f5045794f6b544eb9.png">
                    </figure>
                  </td>
                </tr>
                <tr>
                  <td style="padding:16px;width:500px;">Discreet Under Clothes</td>
                  <td style="background-color:#4d4d4d59;padding:16px;text-align:center;vertical-align:top;width:500px;">
                    <img src="https://cdn.skyfastimg.com/images/2026/03/19/image-69bbbae77dd187b38abd302a.png">
                  </td>
                  <td style="padding:16px;text-align:center;vertical-align:top;width:500px;"><img
                      src="https://cdn.skyfastimg.com/images/2026/03/19/image-69bbbb3f5045794f6b544eb9.png"></td>
                </tr>
                <tr>
                  <td style="padding:16px;width:500px;">Inner-Thigh Coverage</td>
                  <td style="background-color:#4d4d4d59;padding:16px;text-align:center;vertical-align:top;width:500px;">
                    <img src="https://cdn.skyfastimg.com/images/2026/03/19/image-69bbbae77dd187b38abd302a.png">
                  </td>
                  <td style="padding:16px;text-align:center;vertical-align:top;width:500px;"><img
                      src="https://cdn.skyfastimg.com/images/2026/03/19/image-69bbbb3f5045794f6b544eb9.png"></td>
                </tr>
                <tr>
                  <td style="padding:16px;width:500px;">Dry-Touch Feel</td>
                  <td style="background-color:#4d4d4d59;padding:16px;text-align:center;vertical-align:top;width:500px;">
                    <img src="https://cdn.skyfastimg.com/images/2026/03/19/image-69bbbae77dd187b38abd302a.png">
                  </td>
                  <td style="padding:16px;text-align:center;vertical-align:top;width:500px;"><img
                      src="https://cdn.skyfastimg.com/images/2026/03/19/image-69bbbb3f5045794f6b544eb9.png"></td>
                </tr>
                <tr>
                  <td style="padding:16px;">Potential Savings: $600+ / Year</td>
                  <td style="background-color:#4d4d4d59;padding:16px;text-align:center;vertical-align:top;"><img
                      src="https://cdn.skyfastimg.com/images/2026/03/19/image-69bbbae77dd187b38abd302a.png"></td>
                  <td style="padding:16px;text-align:center;vertical-align:top;"><img
                      src="https://cdn.skyfastimg.com/images/2026/03/19/image-69bbbb3f5045794f6b544eb9.png"></td>
                </tr>
                <tr>
                  <td style="padding:16px;">
                    <p>Reusable &amp; Washable</p>
                    <p>&nbsp;</p>
                    <p>&nbsp;</p>
                  </td>
                  <td style="background-color:#4d4d4d59;padding:16px;text-align:center;vertical-align:top;"><img
                      src="https://cdn.skyfastimg.com/images/2026/03/19/image-69bbbae77dd187b38abd302a.png"></td>
                  <td style="padding:16px;vertical-align:top;">
                    <p style="text-align:center;"><img
                        src="https://cdn.skyfastimg.com/images/2026/03/19/image-69bbbb3f5045794f6b544eb9.png"></p>
                  </td>
                </tr>
              </tbody>
            </table>
          </figure>
        </div>
      </div>
    </div>
  </div>
</div>

`;
export default html;
